import { Table as AntTable, type TableProps as AntTableProps } from 'antd';
import { useFela } from 'react-fela';

import * as felaRules from './Table.rules';
import { TablePagination, type TablePaginationProps } from './TablePagination';

export interface TableProps<T extends {}> extends AntTableProps<T> {
    pagination: TablePaginationProps;
}

export const Table = <T extends {} = {}>({ classNames, pagination, ...props }: TableProps<T>) => {
    const { css } = useFela();

    return (
        <div className={css(felaRules.container)}>
            <AntTable<T>
                classNames={{
                    header: { row: css(felaRules.tableHeaderRow), cell: css(felaRules.tableHeaderCell) },
                    body: { row: css(felaRules.tableRow), cell: css(felaRules.tableCell) },
                    content: css(felaRules.table),
                    ...classNames,
                }}
                pagination={false}
                {...props}
            />
            <TablePagination {...pagination} />
        </div>
    );
};
